
export const AmexIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='37'
    height='22'
    fill='none'
    viewBox='0 0 37 22'
  >
    <path
      fill='#1477BE'
      d='M34.985 21.827H1.891a1.5 1.5 0 0 1-1.066-.417 1.52 1.52 0 0 1-.467-1.052V1.456C.373 1.059.542.684.83.412c.287-.273.668-.42 1.062-.412h33.094c.394-.008.775.14 1.062.412s.456.647.471 1.044v18.902c-.012.399-.18.777-.467 1.052s-.67.425-1.066.417'
    />
    <path
      fill='#fff'
      d='M6.128 11.186h2.067L7.113 8.729zm19.02-2.11h-3.334v1.092h3.334v1.271h-3.334v1.275h3.427v.91a19 19 0 0 1 1.802-2l.63-.73-2.518-2.8v1z'
    />
    <path
      fill='#fff'
      d='M34.896 6.363h-5.05l-1.174 1.275L27.6 6.363H15.78l-.903 2.181-.992-2.185H5.212l-3.593 8.647h4.33l.54-1.456H7.75l.562 1.456h19.206l1.17-1.365 1.175 1.365h5.05l-3.985-4.276zM19.024 13.73H17.58V9.003l-2.067 4.728h-1.171l-2.067-4.728-.09 4.728H9.305l-.545-1.456H5.783l-.63 1.456H3.62l2.625-6.184h2.167l2.31 5.639V7.547h2.346l1.895 4.093 1.722-4.093h2.346v6.184zm13.257 0h-1.804l-1.805-2.084-1.802 2.084h-6.503V7.547h6.762l1.625 2.001 1.802-2h1.805l-2.787 3.08z'
    />
  </svg>
);

